import { createContext } from 'react';
export const AccessCheckEvaluationContext = /*#__PURE__*/createContext(null);